// Central asset URLs — replace these URLs to personalise the site
export const assets = {
  // Brand marks
  logo: "https://customer-assets.emergentagent.com/job_kat-branding-hub/artifacts/utu89ge1_KAT%20Consulting1.jpeg",
  bookkatLogo: "https://customer-assets.emergentagent.com/job_kat-branding-hub/artifacts/9nasq8cc_Bookkat%20Logo.jpeg",

  // Founder portraits (all replaceable)
  founderWhite:
    "https://customer-assets.emergentagent.com/job_kat-branding-hub/artifacts/hmt51i1o_WhatsApp%20Image%202026-06-27%20at%202.34.46%20AM.jpeg", // white blazer beside KAT sign
  founderOrange:
    "https://customer-assets.emergentagent.com/job_kat-branding-hub/artifacts/zdyiv9nz_WhatsApp%20Image%202026-06-27%20at%202.34.47%20AM.jpeg", // orange blazer with blue tassel earrings
  founderThroneNew:
    "https://customer-assets.emergentagent.com/job_kat-branding-hub/artifacts/ubhra2yb_Karlene-on-throne.jpeg", // black dress + pearls on throne
  founderThroneCrown:
    "https://customer-assets.emergentagent.com/job_kat-branding-hub/artifacts/6c4wv0ng_WhatsApp%20Image%202026-06-27%20at%202.34.47%20AM%20%282%29.jpeg", // throne with crown (editorial)

  // Illustration (available if needed elsewhere)
  professionalDev:
    "https://customer-assets.emergentagent.com/job_kat-branding-hub/artifacts/rqbrq5mj_WhatsApp%20Image%202026-06-27%20at%202.34.47%20AM%20%281%29.jpeg",

  // BOOKKAT training / speaking engagement
  bookkatLearning:
    "https://customer-assets.emergentagent.com/job_kat-branding-hub/artifacts/yhbtag59_Bookkat%20Learning.png",

  // Contact page — elegant call-center agent
  callAgent:
    "https://images.pexels.com/photos/7689659/pexels-photo-7689659.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=1200",

  // Supporting photography (replaceable placeholders)
  bookkeeping:
    "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=1200&q=80&auto=format&fit=crop",
  property:
    "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1200&q=80&auto=format&fit=crop",
};
